const permissionsSvcBaseUrl = process.env.REACT_APP_PERMISSIONS_API_URL;

const request = async (url, options = {}) => {
  const res = await fetch(url, {
    credentials: 'include',
    mode: 'cors',
    cache: 'no-cache',
    ...options,
    headers: { Accept: 'application/json', ...options.headers },
  });
  if (!res.ok) {
    const error = new Error(await res.text() || `Request failed (${res.status})`);
    error.status = res.status;
    throw error;
  }
  return res.json();
};

// Deployed Didomi targets -> flow id for one Didomi organization, keyed by
// Sourcepoint platform, e.g. { web: { "www.example.com": "DDF-8821" }, app: {}, amp: {}, ott: {} }.
// Targets keep the order of the notices Didomi returned.
export const getDomainFlowIds = (ddmOrganizationId) =>
  request(`${permissionsSvcBaseUrl}/ddm-admin-api/domain-flow-ids?ddm_organization_id=${encodeURIComponent(ddmOrganizationId)}`);

// The account's currently migrated properties, keyed by property id,
// e.g. { "123": { "dateMigrated": "2026-10-07T14:03:00.000Z" } }.
export const getMigratedProperties = () =>
  request(`${permissionsSvcBaseUrl}/accounts/migrated-properties`);

// siteId is sent as a query param so permissions-service can check route and site access.
export const migrateProperty = (propertyId) =>
  request(`${permissionsSvcBaseUrl}/ddm-admin-api/migrate-property?siteId=${encodeURIComponent(propertyId)}`, { method: 'POST' });
